import React, { useState } from 'react';
import { usePriceContext } from '../context/PriceContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faImage, faXmark } from '@fortawesome/free-solid-svg-icons';

const ModalPrice = ({ onClose, types = [] }) => {
  const { addPrice } = usePriceContext();
  const [form, setForm] = useState({
    type: types[0] || '',
    partNumber: '',
    brand: '',
    analog: '',
    name: '',
    stock: '',
    priceRub: '',
    priceEur: '',
    weight: '',
    supply: '',
    comment: '',
  });
  const [photo, setPhoto] = useState(null); // data:image/...;base64,...

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const handleFile = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onloadend = () => setPhoto(reader.result);
    reader.readAsDataURL(file);
  };

  const handleSave = async () => {
    if (!form.partNumber.trim() || !form.name.trim() || !form.type.trim()) {
      alert('Заполните тип, артикул и наименование');
      return;
    }
    try {
      await addPrice({ ...form, photo });
      onClose();
    } catch (e) { alert(e.message); }
  };

  return (
    <div className="modal-overlay">
      <div className="task-modal admin-modal price-modal">
        <header className="task-modal__header">
          <h2 className="task-modal__title">Новая позиция прайса</h2>
          <button className="task-modal__close" onClick={onClose}>×</button>
        </header>

        <div className="task-modal__body">
          <div className="admin-modal__grid">
            <div className="admin-modal__field admin-modal__field--full">
              <label className="admin-modal__label">Тип</label>
              <input
                className="admin-modal__input"
                list="price-types"
                value={form.type}
                onChange={set('type')}
                placeholder="Культиваторы, Молотковые ножи…"
              />
              <datalist id="price-types">
                {types.map(t => <option key={t} value={t} />)}
              </datalist>
            </div>

            <div className="admin-modal__field">
              <label className="admin-modal__label">Артикул</label>
              <input className="admin-modal__input" value={form.partNumber} onChange={set('partNumber')} />
            </div>
            <div className="admin-modal__field">
              <label className="admin-modal__label">Бренд</label>
              <input className="admin-modal__input" value={form.brand} onChange={set('brand')} />
            </div>
            <div className="admin-modal__field admin-modal__field--full">
              <label className="admin-modal__label">Оригинал/Аналог</label>
              <input className="admin-modal__input" value={form.analog} onChange={set('analog')} />
            </div>
            <div className="admin-modal__field admin-modal__field--full">
              <label className="admin-modal__label">Наименование</label>
              <input className="admin-modal__input" value={form.name} onChange={set('name')} />
            </div>
            <div className="admin-modal__field">
              <label className="admin-modal__label">Остаток</label>
              <input className="admin-modal__input" value={form.stock} onChange={set('stock')} />
            </div>
            <div className="admin-modal__field">
              <label className="admin-modal__label">Цена, ₽ Склад</label>
              <input className="admin-modal__input" value={form.priceRub} onChange={set('priceRub')} />
            </div>
            <div className="admin-modal__field">
              <label className="admin-modal__label">Цена, € Заказ</label>
              <input className="admin-modal__input" value={form.priceEur} onChange={set('priceEur')} />
            </div>
            <div className="admin-modal__field">
              <label className="admin-modal__label">Вес, кг</label>
              <input className="admin-modal__input" value={form.weight} onChange={set('weight')} />
            </div>
            <div className="admin-modal__field">
              <label className="admin-modal__label">Поставка</label>
              <input className="admin-modal__input" value={form.supply} onChange={set('supply')} />
            </div>
            <div className="admin-modal__field admin-modal__field--full">
              <label className="admin-modal__label">Комментарий</label>
              <textarea className="admin-modal__textarea" value={form.comment} onChange={set('comment')} />
            </div>

            <div className="admin-modal__field admin-modal__field--full">
              <label className="admin-modal__label">Фото</label>
              <div className="price-photo-uploader">
                <label className="price-photo-btn" htmlFor="price-photo-input">
                  <FontAwesomeIcon icon={faImage} />
                  <span>Прикрепить фото</span>
                </label>
                <input
                  id="price-photo-input"
                  type="file"
                  accept="image/*"
                  onChange={handleFile}
                  style={{ display: 'none' }}
                />
                {photo && (
                  <div className="price-photo-preview">
                    <img src={photo} alt="" />
                    <button
                      className="price-photo-remove"
                      onClick={() => setPhoto(null)}
                      title="Удалить фото"
                    >
                      <FontAwesomeIcon icon={faXmark} />
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        <footer className="task-modal__footer">
          <button className="task-modal__btn task-modal__btn--ghost" onClick={onClose}>Отмена</button>
          <button className="task-modal__btn task-modal__btn--primary" onClick={handleSave}>Сохранить</button>
        </footer>
      </div>
    </div>
  );
};

export default ModalPrice;